import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, CircularProgress, Paper, Tab, Tabs, Typography,
} from '@mui/material';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { getCollection } from '../services/firestoreService';
import HonorariosContratosTab from '../components/HonorariosContratosTab';
import HonorariosAjustesTab from '../components/HonorariosAjustesTab';
import HonorariosLiquidacionesTab from '../components/HonorariosLiquidacionesTab';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const TABS = [
  { label: 'Contratos', index: 0 },
  { label: 'Ajustes', index: 1 },
  { label: 'Liquidaciones', index: 2 },
];

export default function HonorariosMedicos() {
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [professionals, setProfessionals] = useState([]);
  const [clinics, setClinics] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [branches, setBranches] = useState([]);
  const [tiposPrestacion, setTiposPrestacion] = useState([]);
  const [aranceles, setAranceles] = useState([]);

  const loadAll = useCallback(async () => {
    setLoading(true);
    try {
      const [profsData, clinicsData, specsData, branchesData, tiposData, arancelesData] = await Promise.all([
        getCollection('professionals'),
        getCollection('clinics'),
        getCollection('specialties'),
        getCollection('branches'),
        getCollection('tiposPrestacion'),
        getCollection('aranceles'),
      ]);
      setProfessionals(profsData.filter((p) => p.active !== false));
      setClinics(clinicsData.filter((c) => c.active !== false));
      setSpecialties(specsData.filter((s) => s.active !== false));
      setBranches(branchesData.filter((b) => b.active !== false));
      setTiposPrestacion(tiposData);
      setAranceles(arancelesData.filter((a) => a.activo !== false));

      const usersSnap = await getDocs(query(
        collection(db, 'users'),
        where('role', 'in', ['Médico Veterinario', 'Radiologo']),
      ));
      setUsers(usersSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error('Error cargando Honorarios Médicos:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 800 }}>
        Honorarios Médicos
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Gestión de contratos y liquidación de honorarios para médicos veterinarios y radiólogos.
      </Typography>

      <Paper sx={{ mt: 3, borderRadius: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          {TABS.map((t) => <Tab key={t.index} label={t.label} />)}
        </Tabs>

        <TabPanel value={tab} index={0}>
          <HonorariosContratosTab
            users={users}
            professionals={professionals}
            clinics={clinics}
            specialties={specialties}
            branches={branches}
            tiposPrestacion={tiposPrestacion}
            aranceles={aranceles}
          />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <HonorariosAjustesTab professionals={professionals} />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <HonorariosLiquidacionesTab professionals={professionals} />
        </TabPanel>
      </Paper>
    </Box>
  );
}
